import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_350: DocMigration = {
  maxSchemaVersion: "0.0.350",
  description: "Remove 'PLAN_EDGE_NOTE' annotations",
  apply(json: any) {
    for (const id in json.annotation) {
      if (json.annotation[id].type === "PLAN_EDGE_NOTE") {
        delete json.annotation[id];
      }
    }

    return json;
  },
};

export default migration_0_0_350;
